module.exports = function() {
  return new Worker(__webpack_public_path__ + "38128dab2e86ea0b090e.worker.js");
};